import { fetchFromOldApi } from '~/services/Http';

export const putEmpRoles = async (userName: string, json: string[]) => {
  return await fetchFromOldApi(`/json/user/${userName}/roles`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(json),
  }).then((r) => r.json());
};

export const getEmpRoles = async (userName: string) => {
  return await fetchFromOldApi(`/json/user/${userName}/roles`, {}).then((r) =>
    r.json(),
  );
};
